import React, {useEffect, useState} from "react";
import Select from 'react-select';
import {ReactSelect} from "../../../types/ReactSelect";
import MerchantService from "../../../services/MerchantService";

import {useDispatch} from 'react-redux';
import {fetchAndSetValue} from '../../../slices/merchant/slice';
import { AppDispatch} from '../../../slices/merchant/store';
import {useTranslation} from "react-i18next";

interface SelectMerchantInterface {
    disabled?: boolean;
    merchantId?: string | null;
    onMerchantChange?: (merchant: ReactSelect | null) => void;

}

export const SelectMerchant: React.FC<SelectMerchantInterface> = ({disabled, merchantId,onMerchantChange}) => {

    const {t} = useTranslation(); // Get the translation function

    const dispatch = useDispatch<AppDispatch>();

    // Fix type here to match the expected values: ReactSelect | null
    const [selectedValue, setSelectedValue] = useState<ReactSelect | null>(null);
    const [isLoadingMerchants, setLoadingMerchants] = useState<boolean>(true);
    const [merchants, setMerchants] = useState<ReactSelect[]>();

    const loadMerchants = async () => {
        setLoadingMerchants(true);
        try {
            const merchants: ReactSelect[] = await MerchantService.fetchMerchantSelect();
            setMerchants(merchants);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoadingMerchants(false);
        }
    };

    const handleSelectChange = (selected: ReactSelect | null, actionMeta: any) => {
        if (selected) {
            setSelectedValue(selected); // Correctly handles ReactSelect type
            // dispatch(fetchAndSetValue({[actionMeta.name]: selected.value}));
            dispatch(fetchAndSetValue({SelectedMerchant: selected.value}));
            localStorage.setItem("SelectedMerchant", JSON.stringify(selected));
            // console.log(selected)
            if(selected){
                if (onMerchantChange) {
                    onMerchantChange(selected);
                    // console.log(selected)
                }
            }
        } else {
            setSelectedValue(null);
            // dispatch(fetchAndSetValue({[actionMeta.name]: ""}));
            dispatch(fetchAndSetValue({SelectedMerchant: ''}));
            localStorage.removeItem("SelectedMerchant");
            if (onMerchantChange) {
                onMerchantChange(null);
            }
        }
    };

    useEffect(() => {
        // console.log("SelectMerchant -> useEffect")
        loadMerchants();
    }, []);

    // useEffect(() => {
    //     const selectedMerchant = localStorage.getItem("SelectedMerchant");
    //     if(selectedMerchant){
    //
    //     }
    // }, []);

    useEffect(() => {

        if (merchantId && merchants) {
            const selectedMerchant = merchants.find((merchant) => merchant.value === merchantId);
            setSelectedValue(selectedMerchant || null); // Correctly handles ReactSelect | null
        }


    }, [merchantId, merchants]);


    return (
        <div>
            {/*{merchantId}*/}
            <Select
                isMulti={false}
                value={selectedValue}
                onChange={handleSelectChange}
                classNamePrefix="mb-0"
                options={merchants}
                isLoading={isLoadingMerchants}
                isDisabled={disabled}
                isClearable={true}
                id="merchant-select"
                name="merchant_id"
                placeholder={<span style={{ color: "gray" }}>{t('Choose Merchant..')}</span>}
            />
        </div>
    );
};

export default SelectMerchant;
